import { Switch, useRouteMatch, Route } from 'react-router-dom';

import LeadList from './LeadList/LeadList';
import LeadDataHandler from './Context/LeadContext';
import LeadDetails from './LeadDetails/LeadDetails';
import OnlineLeadsList from './LeadList/components/OnlineLeads/OnlineLeadsList';

function LeadRouter() {
  let { path } = useRouteMatch();
  return (
    <LeadDataHandler>
      <Switch>
        <Route exact path={path} component={LeadList} />
        <Route path={`${path}/:id`} component={LeadDetails} />
        <Route exact path={`${path}/online`} component={OnlineLeadsList} />
      </Switch>
    </LeadDataHandler>
  );
}

export default LeadRouter;
